// View.js
import React from 'react';

const View = ({ data }) => {
  return (
    <div className="block audioblock view">
      {data.url && (
        <audio controls src={data.url}>
          Your browser does not support the audio element.
        </audio>
      )}
    </div>
  );
};

export default View;
